

import { instantiate } from './math-blaster-wasm-js.uninstantiated.mjs';

const exports = (await instantiate({

})).exports;

export default new Proxy(exports, {
    _shownError: false,
    get(target, prop) {
        if (!this._shownError) {
            this._shownError = true;
            throw new Error("Do not use default import. Use the corresponding named import instead.")
        }
    }
});
export const {
    main,
    _initialize,
    memory
} = exports;

